const OperatorCell = ({ lead_operators_lead }) => {
  if (lead_operators_lead === null || lead_operators_lead === undefined || lead_operators_lead.length === 0) {
    return "-";
  }
  
  return lead_operators_lead[0].operator 
    ? `${lead_operators_lead[0].operator.username}`.trim() || "-" 
    : "-";
};

export default OperatorCell;
